import React from 'react';
import PropTypes from 'prop-types';
import Boundary from '../Boundary';
const DISPLAY_NAME = 'DropdownAnchor';
const DropdownAnchor = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Boundary, {
    name: DISPLAY_NAME
  }, children);
};
DropdownAnchor.displayName = DISPLAY_NAME;
process.env.NODE_ENV !== "production" ? DropdownAnchor.propTypes = {
  /**
   * Sets the children.
   */
  children: PropTypes.node
} : void 0;
export default DropdownAnchor;